import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { IzinKaydiEditComponent } from './izin-kaydi-edit.component';
import { IzinKaydiKartComponent } from './izin-kaydi-kart.component';

@DinamikBilesen({
  id: 'izin-kaydi',
  baslik: 'İzin Kaydı',
  aciklama: 'İzin kaydı ekle',
  ikon: 'calendar',
  kategori: 'personel',
})
class IzinKaydi {
  paylas_kutusu = IzinKaydiEditComponent;
  paylasilmis_kart = IzinKaydiKartComponent;
}
